<template>
  <div class="columns is-vcentered">
    <div
      class="column"
      v-for="[name, elementSchema] in visibleFields"
      :key="key(elementSchema, name)"
      :class="{ 'is-narrow': columnIsNarrow(elementSchema) }"
    >
      <schema-form-element
        :schema="elementSchema"
        :on-action-callback="onActionCallback"
        v-model="form[name]"
      />
    </div>
  </div>
</template>

<script>
import SchemaFormElement from './SchemaFormElement'
import { mergeDeep } from '@/utils/objects'

export default {
  name: 'SchemaForm',
  components: {
    SchemaFormElement
  },
  props: {
    schema: {
      type: Object
    },
    value: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      form: {}
    }
  },
  computed: {
    visibleFields() {
      let result = []
      const sortFunction = (e1, e2) => {
        let index1 = typeof e1[1].index === 'number' ? e1[1].index : 1000
        let index2 = typeof e2[1].index === 'number' ? e2[1].index : 1000
        return index1 - index2
      }
      const sortedProps = Object.entries(this.schema.properties).sort(sortFunction)

      for (const [name, schema] of sortedProps) {
        if (this.shouldDisplay(schema)) {
          result.push([name, schema])
        }
      }

      return result
    }
  },
  watch: {
    form(newForm) {
      this.form = newForm
      this.emitInput()
    },
    value(newValue) {
      if (newValue) {
        this.form = newValue
        this.emitInput()
      }
    }
  },
  methods: {
    key(schema, name) {
      return `${schema.title}-${name}`
    },
    emitInput() {
      this.$emit('input', this.form)
    },
    onActionCallback(action) {
      const { update } = action

      if (typeof update !== 'undefined') {
        this.schema = mergeDeep(this.schema, update)
      }
    },
    shouldDisplay(elementSchema) {
      if (elementSchema.exists !== undefined) {
        return elementSchema.exists
      }

      return true
    },
    columnIsNarrow(schema) {
      return !(schema.type === 'array' && typeof schema.examples !== 'undefined')
    }
  }
}
</script>
